import { CardTile, XStack } from '@shinetools/lumen-react'
import { type ChangeEvent, type ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { type ExportDocumentFileType } from '../../types/exportDocumentFileType'
import { ExportDrawerSection } from '../ExportDrawerSection'
import { exportDocumentFileTypeToTKey } from './constants/exportDocumentFileTypeToTKey'

interface ExportFileTypeSectionProps {
  fileTypes: ExportDocumentFileType[]
  onChange: (fileType?: ExportDocumentFileType) => void
  value?: ExportDocumentFileType
}

export const ExportFileTypeSection = ({ fileTypes, onChange, value }: ExportFileTypeSectionProps): ReactElement => {
  const { t } = useTranslation()

  const handleFileTypeTileChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { checked, value: tileValue } = event.target
      const fileType = fileTypes.find((availableFileType) => availableFileType === tileValue)

      onChange(checked ? fileType : undefined)
    },
    [fileTypes, onChange],
  )

  return (
    <ExportDrawerSection title={t('export_drawer.format')}>
      <XStack gap={8}>
        {fileTypes.map((fileType) => (
          <CardTile
            action="check"
            key={fileType}
            label={t(exportDocumentFileTypeToTKey[fileType])}
            onChange={handleFileTypeTileChange}
            selected={value === fileType}
            value={fileType}
            variant="inline"
          />
        ))}
      </XStack>
    </ExportDrawerSection>
  )
}
